module.exports = __webpack_public_path__ + "img/index_qrcode.05f68a40.jpg";